const OTH = {
  countryConfig: {
    accountNumber: {
      required: false,
      visible: true,
      label: "bankDetails.accountNumber",
    },
    accountHolderDocNumber: {
      label: "bankDetails.idNumber",
      required: true,
    },
    bankName: {
      visible: true,
      label: "bankDetails.bankName",
      required: true,
    },
    IBAN: {
      visible: true,
      required: false,
      label: "bankDetails.IBAN",
      alphanumeric: true,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
    ClaveBanco: {
      label: "bankDetails.ClaveBanco",
      placeholder: "bankDetails.ClaveBancoPlaceholderBr",
      visible: true,
      required: true,
    },
    swift: {
      visible: true,
      required: true,
      label: "bankDetails.swift",
    },
    accountTypeBankDetails: {
      label: "bankDetails.accountTypeBankDetails",
      visible: true,
      required: true,
    },
  },
};
export { OTH };
